import { render } from "./Widget10.vue?vue&type=template&id=46ce9b5e&ts=true"
import script from "./Widget10.vue?vue&type=script&lang=ts"
export * from "./Widget10.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__